/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';

const customersListSchema = [new schema.Entity('customers')];

export {
  customersListSchema,
};
